<template>
    <div id="sub-account-users-tab" class="sub-account-tab">
        <div class="tab-title">     
            <div class="tab-title-mian">
                <div @click="openSubAccountPopup('addUser','')" style="width: fit-content;">
                    <div class="icon-util sub-add-user tab-title-icon"></div>
                    <span>{{$t('language.popup.subAccountPopup.addUser.title')}}</span>
                </div>
            </div> 
            <div class="tab-title-sub">
                <div class="sub-button" :style="buttonWidth()">
                    <div class="icon-util sub-add-folder tab-title-icon" @click="openSubAccountPopup('addItem',clickSubAccount)"></div>
                    <span @click="openSubAccountPopup('addItem',clickSubAccount)">{{$t('language.popup.subAccountPopup.addItemButton')}}</span>
                </div>
                <div class="sub-button" :style="buttonWidth()">
                    <div class="icon-util sub-quick_assign tab-title-icon" @click="openSubAccountPopup('batchAddItem',clickSubAccount)"></div>
                    <span @click="openSubAccountPopup('batchAddItem',clickSubAccount)">{{$t('language.popup.subAccountPopup.quickAssign')}}</span>
                </div>
            </div>
        </div>
        <div class="tab-body">     
            <div class="main-table">
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr class="tab-th">
                        <th style="padding: 0 20px;">{{$t('language.popup.subAccountPopup.users')}}</th>
                    </tr>
                </table>
                <el-scrollbar style='height:calc(100% - 40px);'>
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr :key="index" v-for="(item,index) in userData" class="tab-tr" @click="getItemList(item)" :class="item.emailId==clickSubAccount?'tab-tr-hover':''">
                        <td :title="item.name" style="padding: 0 10px 0 20px;">
                            <span style="width: 150px;" :title="item.email">{{item.email}}</span>
                            <div class="icon-util remove tab-hover-icon" @click="openDeletePopup('ignore',true,item)" :title="$t('language.common.delete')" v-if="item.delId"></div>
                            <div class="icon-util reedit tab-hover-icon" @click="openSubAccountPopup('editUser',item.subAccount)" :title="$t('language.leftBanner.edit')" v-if="item.subAccount&&item.subAccount.status==2"></div>
                        </td>
                    </tr>
                </table>
                </el-scrollbar>
            </div>
            <div class="sub-table">
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr class="tab-th" :class="($i18n.locale=='deutsch'||$i18n.locale=='japanese'||$i18n.locale=='italian')?'other-tr':''">
                        <th class="th-one">{{$t('language.popup.subAccountPopup.folders')}}</th>
                        <th class="th-two">
                            <div @click.stop="editAllItemLimits('read')" class="table-check-small">
                                <div class="icon-util sub-check" :class="allRead?'check-small':'nocheck-small'"></div>
                            </div>
                            {{$t('language.popup.subAccountPopup.read')}}
                            <div class="icon-util question tab-question">
                                <div class="tab-questionTxt" style="left:530px">{{$t('language.popup.subAccountPopup.questionTxtRead')}}</div>
                            </div>
                        </th>
                        <th class="th-two">
                            <div @click.stop="editAllItemLimits('write')" class="table-check-small">
                                <div class="icon-util sub-check" :class="allWrite?'check-small':'nocheck-small'"></div>
                            </div>
                            {{$t('language.popup.subAccountPopup.write')}}
                            <div class="icon-util question tab-question">
                                <div class="tab-questionTxt" style="left:618px">{{$t('language.popup.subAccountPopup.questionTxtWrite')}}</div>
                            </div>
                        </th>
                    </tr>
                </table>
                <el-scrollbar style='height:calc(100% - 40px);'>
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr :key="index" v-for="(item,index) in itemData" class="tab-tr" 
                    :class="[item.id==clickItemId?'tab-tr-hover':'',($i18n.locale=='deutsch'||$i18n.locale=='japanese'||$i18n.locale=='italian')?'other-tr':'']" @click="clickItemId = item.id">
                        <td class="tr-one" :title="item.folderName">
                            <span>{{item.folderName}}</span>
                            <div class="icon-util remove tab-hover-icon" @click="openDeletePopup('',false,item)" :title="$t('language.common.delete')"></div>
                        </td>
                        <td class="tr-two" >
                            <div @click.stop="addTableCheck(item,0)" class="table-check-small">
                                <div class="icon-util sub-check" :class="item.limits.read?'check-small':'nocheck-small'"></div>
                            </div>
                            {{$t('language.popup.subAccountPopup.allow')}}
                        </td>
                        <td class="tr-two" >
                            <div @click.stop="addTableCheck(item,1)" class="table-check-small">
                                <div class="icon-util sub-check" :class="item.limits.write?'check-small':'nocheck-small'"></div>
                            </div>
                            {{$t('language.popup.subAccountPopup.allow')}}
                        </td>
                    </tr>
                </table>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import '@/assets/css/sub_account_tab.css';
import commonUtils from "@/js/workspace/common_util.js";

export default {
    props:['allPermissionData'],//所有权限
    data: function () {
        return {
            user: commonstate.user,
            userData: [],//左侧子账户
            itemData: [],//右侧权限
            clickSubAccount: "",//当前选中子账号email
            clickItemId: "",//当前选中权限
            allRead: false,//全选读权限
            allWrite: false,//全选写权限
        }
    },
    created(){   
        
    },
    mounted(){
        this.clickSubAccount = "";
        this.clickItemId = "";
    },
    watch:{
        allPermissionData(val){
            this.getSubAccountList();
        }
    },
    methods: {
        //点击修改读写权限
        addTableCheck(item,type){
            let read = item.limits.read;
            let write = item.limits.write;
            switch (type) {
                case 0:
                    read = !item.limits.read;
                    item.limits.read = read;
                    type = "read";
                    break;
                case 1:
                    write = !item.limits.write;
                    item.limits.write = write;
                    type = "write";
                    break;
                default:
                    break;
            }
            this.editPermissionLimits(item,read,write,type);
        },
        //打开子账号弹窗
        openSubAccountPopup(type,item){
            this.$emit("openSubAccountPopup",type,item);
        },
        //打开删除弹窗
        openDeletePopup(type,isUser,item){
            const data = {
                isUser: isUser,//是否是删除子账号
                type: type,//删除类型
                delItem: item,//删除主体
            }
            this.$emit("openSubAccountPopup","delete",data);
        },
        //获取左侧子账号列表
        getSubAccountList(){
            this.clickItemId = "";//清空选中项目
            let leftData = [];
            let isUnRepeat = true;
            this.allPermissionData.forEach(v => {
                isUnRepeat = true;
                for (let i = 0; i < leftData.length; i++) {
                    //重复时，添加权限到itemList
                    if(v.emailId == leftData[i].emailId){
                        if(v.cloudId){
                            //v.name = v.folderName;//排序用
                            leftData[i].itemList.push(v)
                        }
                        //有非空项目权限时，该子用户不可删除
                        if(leftData[i].delId){
                            leftData[i].delId = "";
                        }
                        isUnRepeat = false;
                        break;
                    }
                }
                //未重复时，添加到leftData
                if(isUnRepeat){
                    const item = {
                        //name: v.email,//排序用
                        email: v.email,
                        emailId: v.emailId,
                        itemList: [],
                        delId: "",//是否允许删除，及删除时的id
                        subAccount: []
                    }
                    if(v.cloudId && v.emailId){
                        //非空项目权限加入权限栏
                        //v.name = v.folderName;//排序用
                        item.itemList.push(v)
                    }else{
                        //空项目权限标记可删除
                        item.delId = v.id;
                    }
                    //没有email不添加
                    if(v.emailId){
                        leftData.push(item);
                    }
                }
            });
            this.userData = leftData;

            //根据name排序
            // leftData.forEach(function (item,index) {
            //     item.subList = commonUtils.sortJsonArrName(item.subList,true);
            // })
            // this.userData = commonUtils.sortJsonArrName(leftData,true);

            //判断是否是可控制子账户(延迟添加可控制子账号信息，该请求未反应时，仍可当作不可控制的子账号使用)
            this.Utils.doSubAccountRequest("query", {ud: this.user.id}).then(res => {
                if(res.status=="200"){
                    this.userData.forEach(v => {
                        for (let i = 0; i < res.subList.length; i++) {
                            if(res.subList[i].id == v.emailId){
                                //可控制子账号可修改
                                v.subAccount = res.subList[i];
                                break;
                            }
                        }
                    });
                }else{
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "subAccount"
                    });
                }
            })
            //如果当前已有已选中user，则刷新右侧栏，如果已选择user已经不存在列表，清除clickSubAccount
            //没有选中或选中失效时，默认选中第一个
            if(this.clickSubAccount){
                let isHas = false;
                for (let i = 0; i < this.userData.length; i++) {
                    if(this.userData[i].emailId == this.clickSubAccount){
                        isHas = true;
                        this.getItemList(this.userData[i]);
                        break;
                    }
                }
                if(!isHas){
                    this.clickSubAccount = "";
                    if(this.userData.length>0){
                        this.getItemList(this.userData[0])
                    }
                }
            }else{
                if(this.userData.length>0){
                    this.getItemList(this.userData[0])
                }
            }
        },
        //获取右侧权限列表
        getItemList(sub){
            this.clickSubAccount = sub.emailId;
            this.clickItemId = "";
            this.itemData = sub.itemList;
            this.changAllLimit();
        },
        //修改权限读写
        editPermissionLimits(item,read,write,type){
            let data = {
                ud: commonstate.user.id,
                id: item.id,
                read: read,
                write: write,
                type: type
            }
            let that = this;
            //关闭任意读或写权限，全部读或全部写取消
            switch (type) {
                case "read":
                    this.changAllRead();
                    break;
                case "write":
                    this.changAllWrite();
                    break;
                default:
                    break;
            }
            this.Utils.doPermissionRequest("update_limits", data).then(res => {
                if(res.status=="200"){
                }else{
                    switch (type) {
                        case "read":
                            item.limits.read = !read;
                            //全选状态回退
                            if(item.limits.read){
                                that.changAllRead();
                            }else{
                                that.allRead = false;
                            }
                            break;
                        case "write":
                            item.limits.write = !write;
                            //全选状态回退
                            if(item.limits.write){
                                that.changAllWrite();
                            }else{
                                that.allWrite = false;
                            }
                            break;
                        default:
                            break;
                    }
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "sub-account-users-tab"
                    });
                }
            })
        },
        editAllItemLimits(type){
            if(this.itemData.length<1){
                return;
            }
            //type标识read还是write
            let data = {
                ud: commonstate.user.id,
                emailId: this.clickSubAccount,
                type: type+"_user"
            }
            let that = this;
            if(type=="read"){
                this.allRead=!this.allRead;
                data.read = this.allRead;
                this.itemData.forEach(function(item,index){
                    item.limits.read = that.allRead;
                })
            }else if(type=="write"){
                this.allWrite=!this.allWrite;
                data.write = this.allWrite;
                this.itemData.forEach(function(item,index){
                    item.limits.write = that.allWrite;
                })
            }
            this.Utils.doPermissionRequest("update_all_limits", data).then(res => {
                if(res.status=="200"){
                }else{
                    switch (type) {
                        case "read":
                            that.allRead = !that.allRead;
                            that.itemData.forEach(function(item,index){
                                item.limits.read = that.allRead;
                            })
                            break;
                        case "write":
                            that.allWrite = !that.allWrite;
                            that.itemData.forEach(function(item,index){
                                item.limits.write = that.allWrite;
                            })
                            break;
                        default:
                            break;
                    }
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "sub-account-users-tab"
                    });
                }
            })
        },
        //判断全选按钮
        changAllRead(){
            let temp = true;
            this.itemData.forEach(v => {
                //任意一个为false，即为false
                if(!v.limits.read){
                    temp = v.limits.read;
                    return;
                }
            })
            //全部为true
            this.allRead = temp;
        },
        changAllWrite(){
            let temp = true;
            this.itemData.forEach(v => {
                //任意一个为false，即为false
                if(!v.limits.write){
                    temp = v.limits.write;
                    return;
                }
            })
            //全部为true
            this.allWrite = temp;
        },
        changAllLimit(){
            let read = true;
            let write = true;
            this.itemData.forEach(v => {
                //任意一个为false，即为false
                if(!v.limits.read){
                    read = v.limits.read;
                }
                if(!v.limits.write){
                    write = v.limits.write;
                }
                if(!read&&!write){
                    return;
                }
            })
            //全部为true
            if(this.itemData.length>0){
                this.allRead = read;
                this.allWrite = write;
            }else{
                this.allRead = false;
                this.allWrite = false;
            }
        },
        buttonWidth(){
            if((this.$i18n.locale=='deutsch'||this.$i18n.locale=='france'||this.$i18n.locale=='japanese'||this.$i18n.locale=='italian')){
                return "width:32%;"
            }
        },
    }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_sub_account/tab_users.vue